var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReplyWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icReplyWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-Themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Direct-messages-",
    transform: "translate(-104.000000, -502.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icReplyWhite",
    transform: "translate(104.000000, 502.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2541966,19.9519119 C21.968729,19.9519119 21.6995683,19.7922423 21.5677698,19.5276859 C20.1469544,16.6860552 18.8017266,13.996367 11.5107914,13.8217866 L11.5107914,19.1844725 C11.5107914,19.4895084 11.3302638,19.7651919 11.0513189,19.8873981 C10.7723741,20.0096044 10.4466187,19.9555036 10.222542,19.7479257 L0.246522782,10.5392926 C0.0892086331,10.3948322 0,10.1901319 0,9.97583937 C0,9.76154681 0.0892086331,9.55684657 0.246522782,9.41219429 L10.222542,0.203561197 C10.4466187,-0.00401674111 10.7733333,-0.0571582279 11.0513189,0.0640887745 C11.3302638,0.186486856 11.5107914,0.462170309 11.5107914,0.76720628 L11.5107914,6.1479257 C22.1394724,6.41171467 23.0215827,12.2112351 23.0215827,19.1844725 C23.0215827,19.5403478 22.7765947,19.8492207 22.4303118,19.9317147 C22.3717986,19.9451439 22.3127098,19.9519119 22.2541966,19.9519119 Z M1.89889688,9.97583937 L9.97601918,17.4315708 L9.97601918,13.0453837 C9.97601918,12.6212111 10.3192326,12.2779976 10.7434053,12.2779976 C17.1065707,12.2779976 19.8156355,14.0541128 21.4050839,16.1891727 C21.0461391,10.9523382 19.2207194,7.6736811 10.7434053,7.6736811 C10.3192326,7.6736811 9.97601918,7.33046767 9.97601918,6.90629501 L9.97601918,2.52010796 L1.89889688,9.97583937 Z",
    id: "Reply"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReplyWhite);
export default __webpack_public_path__ + "static/media/icReplyWhite.447a22799c148379fef7f746fac93c1a.svg";
export { ForwardRef as ReactComponent };